import { GalleryHorizontalEnd } from 'lucide-react';
import { memoClassNames } from '@/utils';
import { Toolbar, ToolbarProps, ToolbarTitle } from '@/components/toolbar';
import { Feedback } from '../feedback';
import { useFlashcardContext } from './hooks/use-flashcard-context';
import { FlashcardToolbarProps as BaseFlashcardToolbarProps } from './types';

type FlashcardToolbarProps = BaseFlashcardToolbarProps & ToolbarProps;

const classes = memoClassNames('FlashcardToolbar', ['root']);

export function FlashcardToolbar({
  children: _children,
  title,
  className = '',
  ...others
}: FlashcardToolbarProps) {
  const { deck } = useFlashcardContext();

  return (
    <Toolbar {...others} className={`${classes.root} ${className}`}>
      <div className="mm:flex-shrink-0">
        <GalleryHorizontalEnd size="1em" />
      </div>
      <ToolbarTitle>{title}</ToolbarTitle>
      {deck && (
        <Feedback className="mm:flex-shrink-0" object={`resource:${deck.id}`} />
      )}
    </Toolbar>
  );
}

FlashcardToolbar.displayName = 'FlashcardToolbar';
